import { createSlice } from '@reduxjs/toolkit';
import { ASSESSMENT_REPORT } from '../../actions/Reports/actionAssessmentType';

const assessmentReportInitialState = {
  assessmentReport: {
    assessmentReportdata: [],
    assessmentDetailsReportdata: [],
    assessmentUserReportdata: [],
    assessmentSkillDetailsReportdata: [],
    dropDown: [],
    exportFileData: [],
    exportFileUserData: [],
    isLoading: false,
    errors: ''
  }
};

export const assessmentReportSlice = createSlice({
  name: ASSESSMENT_REPORT,
  initialState: assessmentReportInitialState,
  reducers: {
    /* This action will trigger our saga middleware
       and set the loader to true and reset error message.
    */
    getAssessmentReportAction: (state) => {
      state.isLoading = true;
      state.assessmentReport.errors = '';
    },

    getAssessmentReportSuccessAction: (state, action) => {
      if (action.payload) {
        state.assessmentReport.assessmentReportdata = action.payload[0];
        state.assessmentReport.dropDown = action.payload[1];
      }
      state.assessmentReport.isLoading = false;
    },
    getAssessmentReportFailureAction: (state, action) => {
      state.assessmentReport.isLoading = false;
      state.assessmentReport.errors = action.payload;
    },

    getAssessmentDetaisReportAction: (state) => {
      state.isLoading = true;
      state.assessmentReport.errors = '';
    },

    getAssessmentDetaisReportSuccessAction: (state, action) => {
      if (action.payload) {
        state.assessmentReport.assessmentDetailsReportdata = action.payload;
      }
      state.assessmentReport.isLoading = false;
    },
    getAssessmentDetaisReportFailureAction: (state, action) => {
      state.assessmentReport.isLoading = false;
      state.assessmentReport.errors = action.payload;
    },

    getAssessmentUserReportAction: (state) => {
      state.isLoading = true;
      state.assessmentReport.errors = '';
    },

    getAssessmentUserReportSuccessAction: (state, action) => {
      if (action.payload) {
        state.assessmentReport.assessmentUserReportdata = action.payload;
      }
      state.assessmentReport.isLoading = false;
    },
    getAssessmentUserReportFailureAction: (state, action) => {
      state.assessmentReport.isLoading = false;
      state.assessmentReport.errors = action.payload;
    },
    getAssessmentExportFileAction: (state) => {
      state.isLoading = true;
      state.assessmentReport.errors = '';
    },

    getAssessmentExportFileSuccessAction: (state, action) => {
      if (action.payload) {
        state.assessmentReport.exportFileData = action.payload;
      }
      state.assessmentReport.isLoading = false;
    },
    getAssessmentExportFileFailureAction: (state, action) => {
      state.assessmentReport.isLoading = false;
      state.assessmentReport.errors = action.payload;
    },
    getAssessmentUserExportFileAction: (state) => {
      state.isLoading = true;
      state.assessmentReport.errors = '';
    },

    getAssessmentUserExportFileSuccessAction: (state, action) => {
      if (action.payload) {
        state.assessmentReport.exportFileUserData = action.payload;
      }
      state.assessmentReport.isLoading = false;
    },
    getAssessmentUserExportFileFailureAction: (state, action) => {
      state.assessmentReport.isLoading = false;
      state.assessmentReport.errors = action.payload;
    }
  }
});

/* getUserSuccessAction and getUserErrorAction will be used inside the saga
  middleware. Only getUserAction will be used in a React component.
*/

export const {
  getAssessmentReportAction,
  getAssessmentReportSuccessAction,
  getAssessmentReportFailureAction,
  getAssessmentDetaisReportAction,
  getAssessmentDetaisReportSuccessAction,
  getAssessmentDetaisReportFailureAction,
  getAssessmentExportFileAction,
  getAssessmentExportFileSuccessAction,
  getAssessmentExportFileFailureAction,
  getAssessmentUserReportAction,
  getAssessmentUserReportSuccessAction,
  getAssessmentUserReportFailureAction,
  getAssessmentUserExportFileAction,
  getAssessmentUserExportFileSuccessAction,
  getAssessmentUserExportFileFailureAction
} = assessmentReportSlice.actions;
export default assessmentReportSlice.reducer;
